const en: Record<string, string> = {
  // nav
  'nav.overview': 'Overview',
  'nav.members': 'Members',
  'nav.debates': 'Debates',
  'nav.bills': 'Business',
  'nav.votes': 'Votes',
  'nav.parties': 'Parties',
  'nav.sessions': 'Sessions',
  'nav.committees': 'Committees',
  'nav.chatHistory': 'Chat History',
  'nav.reports': 'Reports',
  'nav.usage':       'Usage',
  'nav.feedback':    'Feedback',
  'nav.documentation': 'Docs',
  'nav.settings': 'Settings',
  // API status (moved from topbar to Settings → System, developer-only)
  'settings.api.title':       'API status',
  'settings.api.health':      'Backend health',
  'settings.api.desc':        'Polled every 60 seconds. Combines Postgres + Meilisearch reachability.',
  'settings.api.ok':          'All systems operational',
  'settings.api.degraded':    'Partially degraded',
  'settings.api.unreachable': 'Unreachable',
  // Admin feedback triage page (/feedback)
  'feedback.title':              'Feedback triage',
  'feedback.subtitle':           'Negative-feedback chat turns paired with the user query that produced them.',
  'feedback.window':             'Window',
  'feedback.errorLoad':          'Failed to load feedback',
  'feedback.kpiDownvotes':       'Downvotes',
  'feedback.noPrior':            'no prior data',
  'feedback.vsPrior':            'vs prior period',
  'feedback.kpiRatio':           'Down ratio',
  'feedback.rated':              'rated',
  'feedback.kpiWithComment':     'With comment',
  'feedback.commentSub':         'have free-form detail',
  'feedback.kpiTopCategory':     'Top category',
  'feedback.topCategorySub':     'most-flagged issue',
  'feedback.categoryHistogram':  'By category',
  'feedback.clearCategory':      'Clear filter',
  'feedback.chartHint':          'Click a bar to filter the list below.',
  'feedback.empty':              'No downvoted answers in this window.',
  'feedback.hasComment':         'comment',
  'feedback.openConversation':   'Open conversation',
  'feedback.userLabel':          'User',
  'feedback.assistantLabel':     'Assistant',
  'feedback.noUserQuery':        '(no preceding user query)',
  'feedback.noAssistantText':    '(no text answer — tool-only turn)',
  'feedback.withComment':        'Has comment',
  'feedback.filterCommentOn':    'Show only items with a free-form comment',
  'feedback.filterCommentOff':   'Showing items with comment — click to clear',
  'feedback.conversation':       'Conversation',
  'feedback.openInChatHistory':  'Open in Chat History',
  'feedback.turns':              'Q&A turns',
  // pagination / drawer shared
  'common.previous':             'Previous',
  'common.next':                 'Next',
  'common.close':                'Close',
  // Feedback affordances (👍 / 👎 / copy + categorised reason modal)
  'chat.feedback.helpful':            'Mark as helpful',
  'chat.feedback.reportProblem':      'Report a problem',
  'chat.feedback.copy':               'Copy answer',
  'chat.feedback.copied':             'Copied',
  'chat.feedback.modal.title':        'What was the problem?',
  'chat.feedback.modal.hint':         'Categorise the issue (optional) and add detail. Both are optional — a bare 👎 is also useful signal.',
  'chat.feedback.modal.category':     'Category',
  'chat.feedback.modal.comment':      'Comment (optional)',
  'chat.feedback.modal.commentPlaceholder': 'What was wrong, what did you expect?',
  'chat.feedback.modal.cancel':       'Cancel',
  'chat.feedback.modal.submit':       'Submit',
  'chat.feedback.cat.inaccurate':                 'Inaccurate',
  'chat.feedback.cat.inaccurate.desc':            'Wrong fact or made-up data',
  'chat.feedback.cat.incomplete':                 'Incomplete',
  'chat.feedback.cat.incomplete.desc':            'Answered only part of the question',
  'chat.feedback.cat.wrong_citation':             'Wrong citation',
  'chat.feedback.cat.wrong_citation.desc':        'Source link broken or points to the wrong entity',
  'chat.feedback.cat.off_topic':                  'Off-topic',
  'chat.feedback.cat.off_topic.desc':             "Didn't answer what was asked",
  'chat.feedback.cat.formatting':                 'Formatting / language',
  'chat.feedback.cat.formatting.desc':            'Wrong language, broken table, etc.',
  'chat.feedback.cat.other':                      'Other',
  'chat.feedback.cat.other.desc':                 'Use the comment to explain',
  'chat.history.pinned':              'Pinned',
  'chat.history.today':               'Today',
  'chat.history.yesterday':           'Yesterday',
  'chat.history.thisWeek':            'This week',
  'chat.history.older':               'Older',
  'chat.fromChat':                    'from chat',
  'common.search':                    'Search',
  'chat.history.newChat':             'New chat',
  'chat.history.searchPlaceholder':   'Search sessions…',
  'chat.history.empty':               'No saved conversations yet. Start one with the chat widget.',
  'chat.history.untitled':            'Untitled chat',
  'chat.history.pin':                 'Pin',
  'chat.history.unpin':               'Unpin',
  'chat.history.rename':              'Rename',
  'chat.history.archive':             'Archive',
  'chat.history.selectHint':          'Select a conversation from the list to read it. New chats start in the chat widget at the bottom right.',
  'chat.history.continue':            'Continue in chat',
  'reports.listTitle':             'Reports',
  'reports.empty':                 'No reports yet. Select conversations in Chat History and generate one.',
  'reports.untitled':              'Untitled report',
  'reports.selectHint':            'Select a report to read it, or generate a new one from your conversations in Chat History.',
  'reports.generatedOn':           'Generated on',
  'reports.sourcesNote':           'Sources link to the official Swiss Parliament website (parlament.ch). Generated with AI from saved conversations — verify against the cited sources.',
  'reports.modelTip':              'Model chosen automatically by report size',
  'reports.downloadPdf':           'PDF',
  'reports.downloadMd':            'Markdown',
  'reports.popupBlocked':          'Please allow pop-ups for this site to download the PDF.',
  'reports.status.failed':         'failed',
  'reports.confirmDelete':         'Delete this report? This cannot be undone.',
  'reports.generateTitle':         'Generate report',
  'reports.generateHint':          'A professional research report will be written from the selected conversation, organised by topic. It cites only official parlament.ch sources.',
  'reports.turnsSelected':         'Turns selected',
  'reports.conversationsSelected': 'Conversations selected',
  'reports.language':              'Report language',
  'reports.lang.de':               'German',
  'reports.lang.fr':               'French',
  'reports.lang.it':               'Italian',
  'reports.lang.en':               'English',
  'reports.generate':              'Generate report',
  'reports.generating':            'Generating…',
  'reports.generateError':         'Could not generate the report. Please try again.',
  'reports.selectSessions':        'Select for report',
  'reports.selectTurns':           'Select for report',
  'reports.selectDone':            'Done selecting',
  'reports.generateN':             'Generate report ({n})',
  'reports.turnsChosen':           '{n} turn(s) selected',
  'common.cancel':                 'Cancel',
  'common.delete':                 'Delete',
  'debates.tab.search':                 'Search',
  'debates.tab.trends':                 'Trends',
  // Trends — compare-factions toggle
  'debates.trends.compareLabel':     '+ compare',
  'debates.trends.exitCompare':      '× compare',
  'debates.trends.compareTooltip':   'Compare multiple parliamentary groups side-by-side',
  'common.errorLoad':                            'Failed to load',
  'debates.trends.title':               'Rhetoric trends',
  'debates.trends.subtitle':            'Year-over-year shifts in how parliamentarians speak — sentiment, stance, federalism orientation, and emotional intensity.',
  'debates.trends.empty':               'No speeches matched the current filters.',
  'debates.trends.allFactions':         'Parliamentary groups',
  'debates.trends.allParties':          'Parties',
  'debates.trends.allSessions':         'Sessions',
  'debates.trends.councillorPlaceholder': 'Council member name…',
  'debates.trends.chunksHint':            'AI-scored chunks across these speeches (long speeches are split for analysis)',
  'faction.cohesion':                'Cohesion',
  'faction.rebels':                  'Rebels',
  'faction.cohesionByYear':          'By year',
  'faction.cohesionByTopic':         'By topic',
  'faction.cohesionYearSubtitle':    'Cohesion percent per year — share of cast votes that aligned with the parliamentary group majority.',
  'faction.cohesionTopicSubtitle':   'Cohesion percent per policy area — lowest first surfaces the most internally split topics.',
  'faction.cohesionSrNote':          'Council of States roll-call data starts in 2022.',
  'faction.rebelsSubtitle':          'Members ranked by how often their Yes/No vote diverged from the parliamentary group majority. Excludes votes where the parliamentary group was tied; minimum 20 cast Yes/No votes.',
  'faction.allChambers':             'Both councils',
  'faction.rebellionRate':           'Divergence rate',
  'faction.rebellionRateTip':        'Diverges ÷ Yes/No cast — the share of Yes/No votes where the member broke ranks.',
  'faction.rebellionDiverges':       'Diverges',
  'faction.rebellionDivergesTip':    'Number of Yes/No votes where the member voted opposite to the parliamentary group majority.',
  'faction.rebellionVotes':          'Y/N cast',
  'faction.rebellionVotesTip':       'Total Yes/No votes the member personally cast that count toward this ranking. Abstentions and votes where the parliamentary group was tied are excluded — that\'s why this differs from the "On Ledger" total on the member profile.',
  'faction.votes':                   'votes',
  'parties.unityRanking':            'Parliamentary group unity ranking',
  'parties.unityRankingTip':         "Each parliamentary group's vote cohesion, split by chamber (National Council and Council of States). Council of States data starts in 2022. Click a bar to open that parliamentary group.",
  'votes.demographics.title':        'Statistics',
  'votes.demographics.subtitle':     'how this vote split across the council',
  'votes.demographics.notParticipating': 'Did not participate',
  'votes.demographics.total':        'Total',
  'votes.demographics.tenure':       'Tenure',
  'tenure.bucket.veteran':           'Veteran',
  'tenure.bucket.newcomer':          'Newcomer',
  'member.member':                   'Member',
  'bills.tab.search':                'Search',
  'bills.tab.analytics':             'Analytics',
  'bills.analytics.title':           'Bill analytics',
  'bills.analytics.subtitle':        'How submissions break down by topic, year, type, department, or intent.',
  'bills.analytics.clickToFilter':   'Click to filter',
  'bills.analytics.yearRange':       'Years',
  'bills.analytics.yearFrom':        'From year',
  'bills.analytics.yearTo':          'To year',
  'bills.analytics.allYears':        'All',
  'common.clear':                    'Clear',
  'bills.analytics.submissions':     'Submissions',
  'bills.analytics.concluded':       'Concluded',
  'bills.analytics.metricsTooltip':  'Submissions counts the affairs submitted for each group in the selected years. Concluded is how many of them have since been settled (status “Erledigt”), with its share shown in brackets.',
  'bills.analytics.topic':           'Topic',
  'bills.analytics.year':            'Year',
  'bills.analytics.affairType':      'Type',
  'bills.analytics.department':      'Department',
  'bills.analytics.intent':          'Intent',
  'bills.analytics.faction':         'Parliamentary group',
  'bills.analytics.party':           'Party',
  'bills.analytics.canton':          'Canton',
  'bills.analytics.council':         'Council',
  'bills.analytics.councillor':      'Council member',
  'bills.analytics.committee':       'Committee',
  'bills.analytics.hiddenDimTip':    'Applied via chatbot. Switch to a visible dimension to leave.',
  'bills.legislativePeriod':         'Leg. period',
  'bills.allLegPeriods':             'Periods',
  'bills.dateRange':                 'Date',
  'bills.fcRecommendation':          'FC recommendation',
  'bills.committeeRecommendation':   'Committee recommendation',
  'filter.tooltip.legislativePeriod': 'Filter by legislative period (52=2023→, 51=2019–23, 50=2015–19)',
  'parties.composition.title':       'Council composition',
  'debates.trends.scoreAxis':           'Score',
  'debates.trends.emotionalityAvg':     'Avg emotionality',
  'debates.trends.metric.sentiment':    'Sentiment',
  'debates.trends.metric.alignment':    'Alignment',
  'debates.trends.metric.federalism':   'Federalism',
  'debates.trends.metric.emotionality': 'Emotionality',
  // anchor
  'anchor.researching': 'Researching:',
  'anchor.clear': 'Clear',
  // common
  'common.all': 'All',
  'common.impact': 'Impact',
  'common.sensitivity': 'Polarization',
  'common.centralization': 'Federalism',
  'common.centralizShort': 'Federalism',
  'common.impact.tooltip': 'How broadly this bill affects Swiss society, economy, or legislation. 1 = narrow/minor, 10 = sweeping/major.',
  'common.sensitivity.tooltip': 'How politically contentious or divisive this topic is. 1 = uncontroversial, 10 = highly polarizing.',
  'common.centralization.tooltip': 'Direction of power shift. 1 = strongly cantonal/local, 10 = strongly federal/centralized.',

  // Phase 4.5 — AI-classified anomaly badges (thresholds match the chat agent's FIELD_GLOSSES)
  'anomaly.controversial':            'Controversial',
  'anomaly.controversial.tooltip':    'Rates how polarizing the business is for Swiss society (economy, politics, law and culture). 1 = low polarization / 10 = strong polarization',
  'anomaly.polarizing':               'Polarizing',
  'anomaly.polarizing.tooltip':       'Rates how polarizing the business is for Swiss society (economy, politics, law and culture). 1 = low polarization / 10 = strong polarization',
  'anomaly.highImpact':               'Impact',
  'anomaly.highImpact.tooltip':       'Rates how strongly the business affects Swiss society (economy, politics, law and culture). 1 = limited impact / 10 = far-reaching impact',
  'anomaly.centralizing':             'Centralizing',
  'anomaly.centralizing.tooltip':     'Rates whether the business unifies and centralizes Swiss society (economy, politics, law and culture). 1 = strengthens federalism / 10 = expands centralism',
  'anomaly.decentralizing':           'Decentralizing',
  'anomaly.decentralizing.tooltip':   'Rates whether the business unifies and centralizes Swiss society (economy, politics, law and culture). 1 = strengthens federalism / 10 = expands centralism',
  'anomaly.minorityReport':           'Minority Report',
  'anomaly.minorityReport.tooltip':   'A committee minority filed a written dissent on this affair (Bekämpft / opposed). The bill carries a counter-proposal beyond the majority position.',
  'anomaly.fastTracked':              'Fast-Tracked',
  'anomaly.fastTracked.tooltip':      'Resolved unusually quickly — under 90 days from submission to final vote. Often signals an expedited procedure (urgency clause).',
  'anomaly.heated':                   'Heated',
  'anomaly.heated.tooltip':           'Emotionally charged speech — emotionality score 7–8 out of 10.',
  'anomaly.confrontational':          'Confrontational',
  'anomaly.confrontational.tooltip':  'Sharply confrontational tone — emotionality score 9 or 10 out of 10.',
  'anomaly.closeVote':                'Close Vote',
  'anomaly.closeVote.tooltip':        'Decided by under 5% margin between Yes and No — a swing of a handful of votes would have flipped the outcome.',
  'anomaly.rapporteur':               'Rapporteur',
  'anomaly.rapporteur.tooltip':       'Official committee spokesperson presenting the bill in plenary — speech carries the committee\'s formal framing.',
  'common.submittedBy': 'Submitted by',
  'common.department': 'Department',
  'common.status': 'Status',
  'common.trigger': 'Trigger',
  'common.words': 'words',
  'common.back': 'Back',
  'common.active': 'Active',
  'common.loading': 'Loading…',
  'common.loadMore': 'Load more',
  'common.clearAll': 'Clear all',
  'common.retry': 'Retry',
  'common.error.title': 'Something went wrong',
  'common.error.body': 'This content could not be loaded. Please try again.',
  'council.NR': 'National Council',
  'council.SR': 'Council of States',
  'council.V': 'United Federal Assembly',
  'council.BR': 'Federal Council',
  'filter.tooltip.party':     'Filter by party affiliation. Multiple parties can be selected together.',
  'filter.tooltip.faction':   'Filter by parliamentary group (V·SVP, S·SP, RL·FDP, M-E·Mitte, G·Grüne, GL·GLP).',
  'filter.tooltip.canton':    'Filter by canton of representation. Pick more than one for cross-canton comparisons.',
  'filter.tooltip.council':   'National Council vs Council of States. Select both to see all parliamentarians.',
  'filter.tooltip.gender':    'Filter members by gender.',
  'filter.tooltip.committee': 'Filter members by current committee membership. Select multiple for intersection queries.',
  'filter.year':              'Year',
  'filter.session':           'Session',
  'filter.tooltip.year':      'Submission year of the bill (Einreichungsjahr) — when it was first introduced. Not the year it was last handled or voted on.',
  'filter.tooltip.session':   'Session within the year (Spring, Summer, Autumn, Winter).',
  'filter.tooltip.status':    'Active = currently sitting members. Former = past members only.',
  // Bills page (4.8 + IWP Bundle 1)
  'filter.tooltip.billType':            'Type of parliamentary instrument: Motion, Postulate, Interpellation, Parliamentary Initiative, etc. Multiple types can be combined.',
  'filter.tooltip.billStatus':          'Current procedural state of the bill (e.g. submitted, in progress, accepted, rejected, withdrawn).',
  'filter.tooltip.department':          'Responsible federal department or office for the bill.',
  'filter.tooltip.number':              'Filter by exact business number, e.g. 24.3145. Wildcards not supported.',
  'filter.tooltip.submittedBy':         'Filter by submitter — council member name, parliamentary group, or institution like Bundesrat or a parliamentary committee.',
  'filter.tooltip.aiTopic':             'AI-classified policy area (e.g. Health, Energy, Migration). One topic per bill — the dominant theme.',
  'filter.tooltip.aiIntent':            'AI-classified intent of the bill (e.g. propose new law, request a report, ask a question).',
  'filter.tooltip.aiAudience':          'AI-classified target audience the bill addresses (citizens, businesses, cantons, etc.).',
  'filter.tooltip.aiTrigger':           'AI-classified external trigger that motivated the bill (court ruling, EU directive, public incident, etc.).',
  'filter.tooltip.aiMinImpact':         'Minimum legislative impact score (1–10). How significantly the bill changes Swiss law or public policy. Scored by AI.',
  'filter.tooltip.aiMinSensitivity':    'Minimum political sensitivity (1–10). Degree of political controversy or cross-party tension. Scored by AI.',
  'filter.tooltip.aiMinCentralization': 'Minimum centralization score (1–10). How strongly the bill shifts authority toward the federal level versus cantons.',
  // Votes page (4.8 + IWP Bundle 1)
  'filter.tooltip.voteYear':            'Year the vote was held (vote date), independent of when the underlying bill was submitted.',
  'filter.tooltip.voteStatus':          'Vote outcome: passed, rejected, tied, or pending.',
  'filter.tooltip.voteKeyword':         'Free-text search across vote titles and underlying bill titles.',
  'filter.tooltip.closeOnly':           'Show only contested votes — those with a margin of 10 votes or fewer between Yes and No.',
  'filter.tooltip.splitOnly':           'Show only votes where at least one parliamentary group was internally split by more than 20%.',
  // Debates page (4.8 + IWP Bundle 1)
  'filter.tooltip.debateYear':          'Year the debate took place.',
  'filter.tooltip.language':            'Language the speech was held in (DE, FR, IT).',
  'filter.tooltip.speaker':             'Free-text filter on speaker name (last-name match works).',
  'filter.tooltip.role':                'Speaker role in the debate: rapporteur, federal council member, ordinary member, etc.',
  'filter.tooltip.sentiment':           'Overall tone of the speech as classified by AI: positive, neutral, or negative.',
  'filter.tooltip.position':            'Stance toward the bill being debated: For, Conditional Support, Neutral, or Against.',
  'filter.tooltip.federalism':          'Federalism orientation of the speech: federal-leaning (centralisation) or cantonal-leaning (decentralisation).',
  'filter.tooltip.amendment':           'Show only speeches where the speaker explicitly proposed an amendment.',
  'filter.tooltip.businessFilter':      'Filter speeches by the underlying business number (e.g. 24.3145).',
  // Sessions page (4.8 + IWP Bundle 1)
  'filter.tooltip.sessionYear':         'Year the session was held.',
  'filter.tooltip.season':              'Type of session: regular spring/summer/autumn/winter session, or a special session.',
  // Committees page (4.8 + IWP Bundle 1)
  'filter.tooltip.committeeType':       'Type of committee: standing committee, supervisory committee, or other special body.',
  'filter.tooltip.committeeActive':     'Filter by whether the committee is currently active or has been dissolved/superseded.',
  'filter.tooltip.commission':          'Filter to a parent standing commission (e.g. APK) and all its bodies — both chambers, sub-committees, and working groups.',
  // Generic (Members search box etc.)
  'filter.tooltip.search':              'Free-text search across name fields. Last-name and partial matches both work.',
  // SessionPicker (IWP Bundle 2)
  'filter.allSessions':                 'Sessions',
  'filter.tooltip.sessionPicker':       'Filter to a specific parliamentary session. Pick the year, then expand to see Spring, Summer, Special sessions inside.',
  // SessionDetail — highly-relevant bills card (IWP Bundle 2)
  'session.highlights.title':           'Most important business this session',
  'session.highlights.subtitle':        'Business items on this session\'s agenda, ranked by AI-assessed significance (impact) and political polarization.',
  'session.highlights.empty':           'No bills with high impact or polarization scores were on the agenda for this session.',
  'empty.noResultsTitle': 'No results match these filters',
  'empty.noResultsHint':  'Try removing one or more filters to broaden the search.',
  'empty.removeFilter':   'Remove this filter',
  'presets.save':              'Save filter',
  'presets.saveTooltip':       'Save current filters as a preset',
  'presets.dropdown':          'Presets',
  'presets.applyHeading':      'Apply preset',
  'presets.manageHint':        'Manage in Settings → Manage Presets',
  'presets.modal.title':       'Save filter',
  'presets.modal.nameLabel':   'Name',
  'presets.modal.namePlaceholder': 'e.g. SVP migration motions Q1 2025',
  'presets.modal.hint':        'Saving with an existing name will overwrite that preset.',
  'presets.modal.cancel':      'Cancel',
  'presets.modal.save':        'Save',
  'presets.modal.saving':      'Saving…',
  'common.results': 'results',
  'common.filteredBy': 'Filtered by',

  // ── Notifications / watchlist ────────────────────────────────────────────
  // Bell + dropdown
  'notif.bell.aria':                 'Notifications',
  'notif.bell.unread':               'unread',
  'notif.dropdown.title':            'Notifications',
  'notif.dropdown.markAllRead':      'Mark all read',
  'notif.dropdown.empty':            "You're all caught up.",
  'notif.dropdown.viewAll':          'View all notifications',
  // Per-row message templates ({affair}, {title}, {status}, {name} are
  // substituted at render time from the notification payload)
  'notif.row.voteResult':            'Final vote on {affair} — {title}',
  'notif.row.billStatus':            "{affair} — {title}: status changed to {status}",
  'notif.row.sessionReminder':       'Session starting soon: {name}',
  'notif.row.memberVote':            '{member} voted {decision} on {affair} — {title}',
  'notif.row.memberSpeech':          '{member} spoke on {affair} — {title}',
  'notif.row.generic':               'New event on a watched item',
  // Secondary detail line on the full /notifications page
  'notif.detail.voteTallies':        'Yes {yes} · No {no} · Abstain {abs}',
  'notif.detail.statusChange':       'From "{from}" to "{to}"',
  // Full /notifications page
  'notif.page.title':                'Notifications',
  'notif.page.subtitle':             "Events on the bills, votes and members you're watching.",
  'notif.page.onlyUnread':           'Only unread',
  'notif.page.markAllRead':          'Mark all read',
  'notif.page.empty':                'No notifications yet.',
  'notif.page.emptyUnread':          'No unread notifications.',
  'notif.page.emptyHint':            'Click the bookmark on a bill to start watching it.',
  // Watch button
  'watch.watch':                     'Watch',
  'watch.watching':                  'Watching',
  'watch.full':                      'Watchlist full (max 100)',
  'watch.error':                     "Couldn't update — try again",
  // Watchlist-management modal (opened from Settings → Manage button)
  'watchlist.modal.title.bills':     'Watched bills',
  'watchlist.modal.title.members':   'Watched members',
  'watchlist.modal.title.votes':     'Watched votes',
  'watchlist.modal.empty.bills':     "You haven't watched any bills yet.",
  'watchlist.modal.empty.members':   "You haven't watched any members yet.",
  'watchlist.modal.empty.votes':     "You haven't watched any votes yet.",
  'watchlist.modal.emptyHint':       'Click the bookmark icon on a detail page to start watching.',
  'watchlist.modal.unavailable':     'Unavailable',
  'watchlist.modal.open':            'Open',
  'watchlist.modal.remove':          'Remove',
  'watchlist.modal.close':           'Close',
  'watchlist.modal.done':            'Done',
  'watchlist.modal.filterBy':        'Filter',
  'watchlist.modal.clearFilter':     'Clear filter',
  // Watchlist tag filter on Bills + Members pages (preset-style chip)
  'watchlistTagFilter.label':        'Tags',
  'watchlistTagFilter.activeLabel':  '{n} tag(s)',
  'watchlistTagFilter.dropdownTitle':'Your watchlist tags',
  'watchlistTagFilter.clear':        'Clear',
  'watchlistTagFilter.andHint':      'Items must carry all selected tags.',
  'watchlistTagFilter.banner':       'Showing your watchlist · {n} {kind}',
  'watchlistTagFilter.taggedLabel':  'tagged',
  'watchlistTagFilter.emptyMatch':   'No watched items match these tags.',
  'watchlistTagFilter.emptyMatchHint':'Try removing a tag from the filter or attach more items from the watchlist modal.',
  // Tag selector popover (opened from the "+" on each item)
  'tags.selector.title':             'Tags',
  'tags.selector.noneYet':           "No tags yet — create one in Settings → Notifications → Tags.",
  'tags.selector.createNew':         'Create new tag',
  'tags.selector.namePlaceholder':   'Tag name',
  'tags.selector.create':            'Create',
  'tags.selector.cancel':            'Cancel',
  'tags.atCap':                      'max 10',
  'tags.full':                       'Item-tag limit reached (max 10)',
  'tags.duplicate':                  'A tag with that name already exists',
  'tags.error':                      "Couldn't update — try again",
  // Settings → Tags catalog manager
  'tagsManager.header':              'Your tags',
  // (tagsManager.empty defined below alongside the create-form copy)
  'tagsManager.hint':                'Deleting a tag also removes it from every item it was attached to.',
  'tagsManager.confirmDelete':       'Delete the tag "{name}"? This removes it from every item it was attached to.',
  'tagsManager.edit':                'Rename / recolor',
  'tagsManager.delete':              'Delete tag',
  'tagsManager.save':                'Save',
  'tagsManager.cancel':              'Cancel',
  'tagsManager.create':              'Create tag',
  'tagsManager.namePlaceholder':     'Tag name',
  'tagsManager.color':               'Color',
  'tagsManager.userCapReached':      'Tag limit reached (max 30 per user)',
  // Empty-state copy when no tags exist yet — updated to point at the
  // creation surface which now lives only here.
  'tagsManager.empty':               'No tags yet. Click "Create tag" above to start organising your watched bills and members.',
  // Filter-chip labels referenced from page components but historically
  // undefined — the chips fell back to displaying the raw key text
  // (e.g. "bills.affairNumber: 22.045") because useT() returns the key
  // itself when missing, not the `|| 'Fallback'` suffix at the call site.
  'bills.affairNumber':       'Affair #',
  'bills.type':               'Type',
  'bills.status':              'Status',
  'bills.department':         'Department',
  'filter.language':          'Language',
  'filter.status':            'Status',
  'debates.role':             'Role',
  'chat.provenanceTooltip':   'Filters applied from chatbot suggestion',
  'common.noResults': 'No results found.',
  'common.clearFilters': 'Clear filters',
  'common.current': 'Current',
  'common.past': 'Past',
  'common.present': 'Present',
  'common.exportCSV': 'Export as CSV',
  'csv.filtersApplied': 'Filters applied',
  'csv.noFilters': 'None (all results)',
  'csv.legislature': 'Legislature',
  'csv.vote': 'Vote',
  'csv.outcome': 'Outcome',
  // filters
  'filter.allParties': 'Parties',
  'filter.allCantons': 'Cantons',
  'filter.allFactions': 'Parliamentary groups',
  'debates.partyTooltip':  'Filter speeches by speaker party. Applies on the trends view; the list groups by parliamentary group.',
  'debates.cantonTooltip': 'Filter speeches by speaker canton.',
  'filter.allCouncils': 'Councils',
  'filter.allGenders': 'Genders',
  'filter.allYears': 'Years',
  'filter.allMembers': 'Members',
  'filter.allCommittees': 'Committees',
  'filter.committee': 'Committee',
  'filter.activeOnly': 'Active',
  'filter.formerOnly': 'Former',
  'sort.by': 'Sort by',
  'sort.name': 'Name',
  'sort.joined': 'Year Joined',
  'sort.dob': 'Date of Birth',
  'sort.cohesion': 'Cohesion',
  'sort.ascending': 'Ascending',
  'sort.descending': 'Descending',
  'sort.submissionDate': 'Submission date',
  'filter.canton': 'Canton (e.g. ZH)',
  'filter.searchName': 'Search by name…',
  // omni search
  'omni.placeholder':  'Search members, bills, votes, speeches…',
  'omni.scopeLabel':   'Search across',
  'omni.hint.members': 'Names, parties, cantons',
  'omni.hint.bills':   'Affairs by keyword',
  'omni.hint.votes':   'Vote titles & subjects',
  'omni.hint.debates': 'Parliamentary speeches',
  'omni.searching':    'Searching…',
  'omni.noResults':    'No results found for',
  'omni.viewAll':      'View all in',
  'omni.kbdNav':       'navigate',
  'omni.kbdOpen':      'open',
  'omni.kbdClose':     'close',
  'filter.party': 'Party',
  'filter.faction': 'Parliamentary group',
  'filter.canton.label': 'Canton',
  'filter.gender':  'Gender',
  'filter.council': 'Council',
  'filter.commission': 'Committee',
  'filter.allCommissions': 'Committees',
  'filter.tooltip.commissionAffair': 'Filter by the parliamentary committee handling the affair.',
  // councils
  'council.nr': 'Nationalrat',
  'council.sr': 'Ständerat',
  'council.bundesrat': 'Federal Council',
  // gender
  'gender.male': 'Male',
  'gender.female': 'Female',
  // members
  'members.title': 'Members / Council members',
  'members.legislativePeriod': 'Leg. period',
  'members.interest':          'Interest',
  'members.interestMinCount':  'Interests',
  'members.occupation':        'Occupation',
  'members.employer':          'Employer',
  'members.nativeLanguage':    'Native lang.',
  'members.subtitle': 'Browse active parliament members.',
  // member detail tabs
  'tab.profile': 'Profile',
  'tab.activity': 'Activity',
  'tab.partyHistory': 'Party History',
  'tab.history': 'History',
  'history.dim.party': 'Party',
  'history.dim.council': 'Council',
  'history.dim.legislation': 'Legislature',
  'history.dim.commission': 'Commission',
  'history.legislature': 'Legislature',
  'member.noHistory': 'No history for this filter.',
  'tab.votingRecord': 'Voting Record',
  'tab.speeches': 'Speeches',
  'tab.bills': 'Bills Submitted',
  // member detail sections
  'member.occupations': 'Occupations',
  'member.interests': 'Declared Interests',
  'member.noOccupations': 'No occupation data available.',
  'member.born': 'Born',
  'member.gender': 'Gender',
  'member.citizenship': 'Citizenship',
  'member.nativeLang': 'Native Lang.',
  'member.marital': 'Marital',
  'member.children': 'Children',
  'member.military': 'Military',
  'member.elected': 'Elected',
  'member.oath': 'Oath',
  'member.joined': 'Joined',
  'member.left': 'Left',
  'member.allMembers': 'Members',
  'member.totalVotes': 'On Ledger',
  'member.totalVotesTip': 'Every vote on this member\'s record, including absences and excused votes. The 90% attendance figure refers to the share of these votes the member actually cast.',
  'member.cast': 'Cast',
  'member.castTip': 'Yes, No and Abstain decisions combined — the votes the member personally cast.',
  'member.yesRate': 'Yes Rate',
  'member.yesRateTip': 'Share of all on-ledger votes where the member voted Yes. Absences are part of the denominator.',
  'member.noRate': 'No Rate',
  'member.noRateTip': 'Share of all on-ledger votes where the member voted No. Absences are part of the denominator.',
  'member.abstainTip': 'Share of all on-ledger votes where the member abstained. Absences are part of the denominator.',
  'member.attendance': 'Attendance',
  'member.attendanceTip': 'Share of votes the member cast (Yes, No or Abstain) out of all eligible votes during their tenure.',
  'member.distribution': 'Voting Distribution',
  'member.paid': 'Paid',
  'member.cohesion': 'Cohesion',
  'member.cohesionTip': 'How often this member votes with their parliamentary group majority on Yes/No decisions.',
  'member.withFaction': 'With group',
  'member.withFactionTip': 'Yes/No votes where this member voted WITH their parliamentary group majority (count and share = cohesion).',
  'member.againstFaction': 'Against group',
  'member.againstFactionTip': 'Yes/No votes where this member voted AGAINST their parliamentary group majority (count and share).',
  'member.withMajority': 'With the majority',
  'member.withMajorityTip': 'Yes/No votes where the member was on the winning side (chamber majority) — regardless of faction.',
  'member.withMinority': 'With the minority',
  'member.withMinorityTip': 'Yes/No votes where the member was on the losing side (chamber minority).',
  'member.votesLoadError': 'Could not load votes.',
  'member.cohesionOverTime': 'Faction loyalty over time',
  'member.cohesionChart.aligned': '{aligned} of {base} group votes',
  'member.cohesionChart.dissent': '{n} against the group',
  'member.dissentOnly': 'Dissent only',
  'member.dissentBadge': 'Dissent',
  'member.compare': 'Compare',
  'member.compareBar': 'Compare {n} members',
  'member.compareHint': 'Select up to 3 members to compare side-by-side',
  'member.clearSelection': 'Clear selection',
  'member.contact': 'Contact & Links',
  'member.topTopics': 'Top Topics',
  'member.noPartyHistory': 'No party history available.',
  // debates
  'debates.title': 'Debates & Speeches',
  'debates.subtitle': 'Search parliamentary speeches and transcripts using semantic AI search.',
  'debates.searchPlaceholder': 'Search speeches semantically or by business number (e.g. \'climate policy\', 25.041)',
  'debates.speakerPlaceholder': 'Speaker name',
  'debates.businessNumberPlaceholder': 'Business number (e.g. 25.218)',
  'debates.emptyTitle': 'Search parliamentary speeches',
  'debates.emptySubtitle': 'Use the search bar above to find speeches by topic using AI semantic search, or filter by speaker name, year, or council.',
  'debates.noResults': 'No speeches found for this query.',
  'debates.semanticMode': 'Semantic search',
  'debates.allLangs': 'Languages',
  'debates.recentSpeeches': 'Recent speeches',
  'debates.debateSessions': 'Debate sessions',
  'debates.sessionUnknown': 'Session',
  'debates.loadingChronology': 'Loading full debate chronology…',
  'debates.loadingMoreDebates': 'Loading more debates…',
  'debates.backToDebates': 'Back to Debates',
  'debates.fullSpeech': 'Full Speech',
  'debates.topSpeakers': 'Top Speakers',
  'debates.topSpeakersOnTopic': 'Top Speakers on this Topic',
  'debates.factionActivity': 'Parliamentary group Activity',
  'debates.contributionToTopic': 'Contribution to Topic',
  'debates.contributionOfTotal': '{count} of {total} speeches on the topic',
  'debates.contributionRank': 'Rank {rank} of {total} speakers on this topic',
  'debates.speeches': 'speeches',
  'debates.speakersCount': 'speakers',
  'debates.newestFirst': 'Newest first',
  'debates.oldestFirst': 'Oldest first',
  'debates.debateThread': 'Debate Thread',
  'debates.speechesInDebate': 'speeches in this debate',
  'debates.singleStatement': 'Single statement',
  'debates.singleStatementTip': 'Only one contribution (usually a statement by the President or rapporteur) — no back-and-forth debate.',
  'debates.viewSpeech': 'View full speech',
  'debates.match': 'match',
  'debates.date': 'Date',
  'debates.council': 'Council',
  'debates.affair': 'Affair',
  'debates.current': 'current',
  'debates.unknownSpeaker': 'Unknown Speaker',
  'debates.noTranscript': 'No transcript text available for this speech.',
  'debates.noTranscriptShort': 'No transcript text available.',
  'debates.viewOnParlament': 'View on parlament.ch',
  'debates.parlamentCh': 'parlament.ch',
  'debates.searchCap': 'search index limit',
  'debates.searchCapTip': 'Full-text search returns at most 1,000 results. Use the year, council, or parliamentary group filters to narrow results.',
  'debates.speechesPerMember': 'per member',
  'debates.factionActivityNote': 'Bar width normalized by parliamentary group size',
  'debates.shareOfResults': 'Share of results',
  'debates.activeMembers': 'Active members',
  'debates.filterByYear': 'Filter by year',
  // AI enriched metadata
  'debates.moreFilters': 'More Filters',
  'debates.aiInsights': 'AI Insights',
  'debates.sentiment': 'Sentiment',
  'debates.position': 'Position',
  'debates.for': 'For',
  'debates.against': 'Against',
  'debates.positive': 'Positive',
  'debates.negative': 'Negative',
  'debates.amendments': 'amendments',
  'debates.proposed': 'proposed',
  'debates.stanceSummary': 'Stance Summary',
  'debates.federal': 'Federal',
  'debates.cantonal': 'Cantonal',
  'debates.federalismStance': 'Federalism stance',
  'debates.federalTip': 'The speaker argues for regulating this at the federal (central) level rather than leaving it to the cantons.',
  'debates.cantonalTip': 'The speaker argues for leaving this to the cantons (decentralized) rather than regulating it at the federal level.',
  'debates.emotionality': 'Emotionality',
  'debates.allRoles': 'Roles',
  'debates.allSentiments': 'Sentiments',
  'debates.allPositions': 'Positions',
  'debates.allFederalism': 'Federalism',
  'debates.federalism': 'Federalism',
  // Speaker-role codes not already covered below (see lib/debateEnums.ts).
  'debates.role.rapporteur': 'Rapporteur',
  'debates.role.procedural': 'Procedural',
  'debates.amendmentOnly': 'Amendment proposed',
  'debates.conditionalSupport': 'Conditional Support',
  'debates.role.proponent': 'Proponent',
  'debates.role.critic': 'Critic',
  'debates.role.expert': 'Expert',
  'debates.role.mediator': 'Mediator',
  'debates.role.stateRep': 'State Representative',
  'common.neutral': 'Neutral',
  // bills
  'bills.title': 'Business Affairs',
  'bills.subtitle': 'Search and browse parliamentary affairs.',
  'bills.searchPlaceholder': 'Search affairs by keyword or number…',
  'bills.semanticMode': 'Semantic search',
  'bills.browseMode': 'Structured browse',
  'bills.type.motion': 'Motion',
  'bills.type.postulate': 'Postulate',
  'bills.type.interpellation': 'Interpellation',
  'bills.type.parlInit': 'Parliamentary Initiative',
  'bills.type.cantonInit': 'Cantonal Initiative',
  'bills.type.groupMotion': 'Group Motion',
  'bills.type.question': 'Question',
  'bills.type.urgentQuestion': 'Urgent Question',
  'bills.type.simpleQuestion': 'Simple Question',
  'bills.type.federalBill': 'Federal Council Bill',
  'bills.type.urgentInterp': 'Urgent Interpellation',
  'bills.type.urgentSimple': 'Urgent Simple Question',
  'bills.type.recommendation': 'Recommendation',
  'bills.type.petition': 'Petition',
  'bills.type.pag': 'Parliamentary Group Question',
  'bills.status.submitted': 'Submitted',
  'bills.status.referred': 'Referred',
  'bills.status.inCommittee': 'In Committee',
  'bills.status.planned': 'Planned / Scheduled',
  'bills.status.finalVote': 'Final Vote',
  'bills.status.concluded': 'Concluded',
  'bills.status.reporting': 'Reporting',
  'bills.status.statement': 'Statement Available',
  'bills.tab.documents': 'Documents',
  'bills.tab.related': 'Related & Votes',
  'bills.tab.relatedBusiness': 'Related Business',
  'bills.related.linked': 'Officially Linked',
  'bills.related.semantic': 'Semantically Similar',
  'bills.related.noSemantic': 'No similar affairs found.',
  'bills.related.votes': 'Linked Votes',
  'bills.tab.fulltext': 'Full Text',
  'bills.tab.council': 'Federal Council',
  'bills.cosignatories': 'Co-signatories',
  'bills.rapporteurs': 'Rapporteurs',
  'bills.preconsultations': 'Responsible Committees',
  'bills.legislativeDocs': 'Legislative Documents',
  'bills.noDocuments': 'No legislative documents available.',
  'bills.botschaft': 'Official Dispatch (Botschaft)',
  // committees
  'committees.title': 'Committees',
  'committees.subtitle': 'Browse parliamentary committees and their members',
  'committees.allCouncils': 'Councils',
  'committees.allCommissions': 'Commissions',
  'committees.national': 'National Council',
  'committees.states': 'Council of States',
  'committees.members': 'members',
  'committees.function': 'Function',
  'committees.backToList': 'Back to Committees',
  'committees.searchPlaceholder': 'Search by name or member…',
  'committees.csv.abbreviation': 'Abbreviation',
  'committees.csv.name': 'Name',
  'committees.csv.council': 'Council',
  'committees.csv.type': 'Type',
  'committees.csv.members': 'Members',
  'committees.filterParty': 'Filter by party',
  'committees.typeAll': 'Types',
  'committees.statusAll': 'Status',
  'committees.statusActive': 'Active',
  'committees.statusInactive': 'Inactive',
  'committees.typePermanent': 'Permanent',
  'committees.typeSpecial': 'Special',
  'committees.typeWorkgroup': 'Working Group',
  'bills.allTypes': 'Types',
  'bills.allStatuses': 'Statuses',
  'bills.allDepartments': 'Departments',
  'bills.exportCSV': 'Export filtered results as CSV',
  'bills.moreFilters': 'More filters',
  'bills.numberFilter': 'Bill number (e.g. 23.4488)',
  'bills.aiFilters': 'Additional Filters',
  'bills.aiFilters.primaryTopic': 'Topics',
  'bills.aiFilters.subTopic': 'Sub-Topics',
  'bills.aiFilters.intent': 'Intents',
  'bills.aiFilters.audience': 'Audiences',
  'bills.aiFilters.trigger': 'Triggers',
  // AI-enum value translations (backend stores canonical English; localized for
  // display only, canonical value is passed back to the API). See lib/affairEnums.ts.
  'affairs.intent.newLegislation':  'New Legislation',
  'affairs.intent.revision':        'Revision / Amendment',
  'affairs.intent.repeal':          'Repeal / Abolition',
  'affairs.intent.executive':       'Executive Instruction',
  'affairs.intent.reporting':       'Reporting / Inquiry',
  'affairs.intent.intlAdaptation':  'International Adaptation',
  'affairs.audience.citizens':         'Citizens (General)',
  'affairs.audience.smes':             'SMEs / Local Economy',
  'affairs.audience.largeEnterprises': 'Large Enterprises',
  'affairs.audience.publicAdmin':      'Public Administration',
  'affairs.audience.vulnerable':       'Socially Vulnerable',
  'affairs.audience.farmers':          'Farmers',
  'affairs.audience.healthcare':       'Healthcare',
  'affairs.audience.education':        'Education',
  'affairs.trigger.popularInitiative':  'Popular Initiative / Referendum',
  'affairs.trigger.intlMandates':       'International Mandates (EU/OECD/UN)',
  'affairs.trigger.judicialRulings':    'Judicial Rulings',
  'affairs.trigger.techShift':          'Technological Shift',
  'affairs.trigger.globalCrisis':       'Global Crisis',
  'affairs.trigger.internalInitiative': 'Internal Initiative',
  'bills.aiFilters.minImpact': 'Impact ≥',
  'bills.aiFilters.minSensitivity': 'Sensitivity ≥',
  'bills.aiFilters.minCentralization': 'Centraliz. ≥',
  'bills.aiFilters.browseOnly': 'AI filters apply in Browse mode only',
  'bills.intelligence.title': 'AI Intelligence',
  'bills.quickStart.title': 'Start exploring — or use the search above',
  'bills.quickStart.byYear': 'By year',
  'bills.submittedBy': 'Submitted by…',
  'bills.timeline.submitted': 'Submitted',
  'bills.timeline.preconsultation': 'Pre-consultation',
  'bills.timeline.parliamentaryVote': 'Parliamentary Vote',
  // votes
  'votes.title': 'Votes',
  'votes.subtitle': 'Browse parliamentary vote summaries.',
  'votes.councilScope.title': 'National Council only',
  'votes.councilScope.tooltip': 'This data covers only National Council (Nationalrat) roll-call votes. The Council of States publishes its individual votes too, but through a separate source that the parliament vote API we sync from does not include.',
  'votes.subtitleBusiness':  'Browse votes grouped by business affair.',
  'votes.allCouncils': 'Councils',
  'votes.dataCoverageNote': 'Note: Individual Council of States (Ständerat) votes are available from 2022, and National Council votes from legislative period 50 (2015). Earlier legislative periods are being added.',
  'votes.bothCouncils': 'Both chambers voted on this bill',
  'votes.oneCouncil': 'Only the {council} voted on this bill',
  'votes.chamberSwitchHint': 'Each chamber votes separately — switch to see the other council’s members',
  'votes.subtitleHeatmap':   'Parliamentary group × vote matrix — spot parliamentary groups that split or align across recent business.',
  'votes.subtitleAnalytics': 'Cohesion, comparison, defection and demographic analysis across the vote record.',
  'votes.analytics.keywordTooltip': 'Restricts the underlying votes by business title or subject — e.g. "climate" narrows the analysis to climate-related votes.',
  'votes.analytics.businessNumberPlaceholder': 'Business # (e.g. 25.482)',
  'votes.analytics.businessNumberTooltip':     'Restrict the analysis to votes on this specific business affair.',
  'votes.analytics.scope.totalVotes':    'votes',
  'votes.analytics.scope.finalVote':     'final',
  'votes.analytics.scope.finalTooltip':  'Consolidated participation across all {events} voting events on business {bnum}. Click to open the final / main vote.',
  'votes.tab.search': 'Search',
  'votes.viewEvents': 'Vote Events',
  'votes.viewBusiness': 'By Business',
  'votes.votingEvents': 'voting events',
  'votes.searchPlaceholder': 'Search by title, subject or business number (e.g. 25.041)…',
  'votes.businessNumberPlaceholder': 'Business ID (e.g. 25.3293)',
  'votes.passed': 'Passed',
  'votes.rejected': 'Rejected',
  'votes.pending': 'Pending',
  'votes.outcome.accepted': 'Bill accepted',
  'votes.outcome.rejected': 'Bill rejected',
  'votes.yes': 'Yes',
  'votes.no': 'No',
  'votes.abstain': 'Abstain',
  'votes.present': 'Present',
  'votes.notPresent': 'Not Present',
  'votes.excused': 'Excused',
  'votes.breakdown': 'Breakdown by Parliamentary group',
  'votes.partyBreakdown': 'Breakdown by Party',
  'votes.individualVotes': 'Individual Votes',
  'votes.councillors': 'council members',
  'votes.showAll': 'Show all',
  'votes.againstFaction': 'Against parliamentary group',
  'votes.seeDebates': 'See debates',
  'votes.surpriseFilter': 'Parliamentary group split',
  'votes.tie': 'Tie',
  // Phase 2b — stance translation labels for inverted votes (popular-
  // initiative Schlussabstimmungen, keyword-match procedural votes).
  'votes.invertedBadge': 'Inverted vote',
  'votes.invertedTooltip.popularInitiative': 'On final votes for popular initiatives parliament votes on a decree recommending rejection — raw Yes adopts the rejection (= against the initiative); raw No rejects the rejection (= for the initiative).',
  'votes.invertedTooltip.keywordMatch': 'This vote\'s question is phrased so that raw Yes means the negative action (rejection / non-entrance / no follow-up) — read Yes as Against the bill and No as For the bill.',
  'votes.invertedTooltip.generic': 'Yes and No on this row read in the opposite direction from the political stance on the underlying bill.',
  'votes.forBill': 'For',
  'votes.againstBill': 'Against',
  'votes.rawMechanicsTooltip': 'Raw Ja/Nein counts — vote mechanics, not stance. See the For/Against row above for the translated stance against the bill.',
  'votes.rawDecisionLabel': 'Raw vote',
  'filter.allStances': 'Stances',
  'filter.tooltip.logicalStance': 'Filter by translated stance against the bill. Set by chatbot navigation; clear or change scope here.',
  'votes.date': 'Date',
  'votes.passRate': 'Pass Rate',
  'votes.contestedSub': '≤10 vote margin',
  'votes.perVote': 'council members / vote',
  'votes.contested': 'Contested',
  'votes.avgParticipation': 'Avg. Participation',
  'votes.closestMargin': 'Closest Margin',
  'votes.closeVotesFilter': 'Close Votes',
  'votes.finalVoteFilter':  'Final votes',
  'votes.finalVoteTag':     'Final vote',
  'votes.finalVoteTooltip': 'Final vote on the affair (Schlussabstimmung)',
  'votes.meaning.yes':         'Yes',
  'votes.meaning.no':          'No',
  'votes.meaning.yesAccept':   'A Yes accepts the bill.',
  'votes.meaning.noReject':    'A No rejects the bill.',
  'votes.meaning.yesReject':   'A Yes rejects the proposal.',
  'votes.meaning.noAccept':    'A No accepts the proposal.',
  'votes.meaning.stichYes':    'Yes backs one of the two proposals.',
  'votes.meaning.stichNo':     'No backs the other proposal.',
  'votes.meaning.yesGeneric':  'A Yes approves the motion put to the vote.',
  'votes.meaning.noGeneric':   'A No rejects the motion put to the vote.',
  'votes.meaning.invertedNote':'Note: on this vote the Yes/No meaning is reversed relative to the underlying proposal.',
  'votes.meaning.stichNote':   'Tie-break: Yes and No each stand for a competing proposal, not for acceptance or rejection.',
  'filter.tooltip.finalOnly': 'Show only final votes (Schlussabstimmung) — procedural and article-by-article votes are excluded.',
  'votes.councillorFilter': 'Council member',
  'votes.decisionFilter':   'Decision',
  'votes.meaningYesFilter': 'Yes means',
  'votes.speechAlignment':  'Speech stance',
  'votes.speechSentiment':  'Speech sentiment',
  'votes.viewHeatmap': 'Heatmap',
  'votes.viewAnalytics': 'Analytics',
  'votes.heatmapEmpty': 'No heatmap data available.',
  'votes.factionCol': 'Parliamentary group',
  // analytics tab (cohesion / comparison / rebels / demographics)
  'votes.analytics.modes.cohesion':     'Cohesion',
  'votes.analytics.modes.comparison':   'Comparison',
  'votes.analytics.modes.rebels':       'Rebels',
  'votes.analytics.modes.demographics': 'Demographics',
  'votes.analytics.allYears':            'Years',
  'votes.analytics.since':               'Since',
  'votes.analytics.yearFromTooltip':     'Only votes from this year onward',
  'votes.analytics.keywordPlaceholder':  'Filter by keyword…',
  'votes.analytics.cohesion.overallLabel':   'Avg. cohesion',
  'votes.analytics.cohesion.overallTooltip': 'Average share of parliamentary group members voting with their majority, across the scoped votes.',
  'votes.analytics.cohesion.acrossVotes':    'across {n} votes',
  'votes.analytics.cohesion.unanimousLabel': 'Unanimous',
  'votes.analytics.cohesion.unanimousSub':   '100% cohesion',
  'votes.analytics.cohesion.unanimousTooltip': 'Votes where the group was fully united — every member voted the same way (100% cohesion).',
  'votes.analytics.cohesion.splitLabel':     'Split',
  'votes.analytics.cohesion.splitSub':       '<80% cohesion',
  'votes.analytics.cohesion.splitTooltip':   'Votes where the group was divided — fewer than 80% of members voted with their group’s own majority.',
  'votes.analytics.cohesion.totalVotesLabel':'Total votes',
  'votes.analytics.cohesion.totalVotesTooltip':'Number of votes included in this analysis after the filters above.',
  'votes.analytics.cohesion.trendTitle':     'Cohesion over time',
  'votes.analytics.cohesion.rankedTitle':    'Most cohesive votes',
  'votes.analytics.comparison.pickFactions': 'Parliamentary groups',
  'votes.analytics.comparison.overallTitle': 'Overall cohesion by parliamentary group',
  'votes.analytics.comparison.trendTitle':   'Yearly cohesion trend',
  'votes.analytics.comparison.factionCol':   'Parliamentary group',
  'votes.analytics.comparison.cohesionCol':  'Cohesion',
  'votes.analytics.comparison.totalVotesCol':'Votes',
  'votes.analytics.comparison.unanimousCol': 'Unanimous',
  'votes.analytics.comparison.splitCol':     'Split',
  'votes.analytics.rebels.title':            'Most frequent defectors',
  'votes.analytics.rebels.allFactions':      'Parliamentary groups',
  'votes.analytics.rebels.minVotes':         'min. {n} votes',
  'votes.analytics.rebels.defections':       'defections',
  'votes.analytics.rebels.tooltip':          'A defection is a vote cast against your own parliamentary group’s majority. The rate is the share of a member’s votes that broke from the group.',
  'votes.analytics.demographics.title':      'Vote behavior by group',
  'votes.analytics.demographics.bucketCol':  'Group',
  'votes.analytics.demographics.yesShareCol':'Yes share',
  'votes.analytics.demographics.yesShareTooltip':'Share of this group’s cast votes (Yes, No and abstentions) that were Yes.',
  'votes.analytics.demographics.yes':        'Yes',
  'votes.analytics.demographics.no':         'No',
  'votes.analytics.demographics.abstain':    'Abstain',
  'votes.analytics.demographics.total':      'Total',
  'votes.analytics.demographics.groupBy.faction': 'By parliamentary group',
  'votes.analytics.demographics.groupBy.party':   'By party',
  'votes.analytics.demographics.groupBy.canton':  'By canton',
  'votes.analytics.demographics.groupBy.gender':  'By gender',
  'votes.analytics.demographics.groupBy.council': 'By council',
  'votes.analytics.demographics.groupBy.tenure':  'Newcomer vs. veteran',
  // sessions
  'sessions.title': 'Sessions',
  'sessions.subtitle': 'Search parliamentary sessions, grouped by year.',
  'sessions.subtitleFiltered': '{count} sessions · {filters}',
  'sessions.live': 'Live',
  'sessions.lp': 'LP',
  'sessions.legislativePeriod': 'Legislative Period',
  'sessions.passedTooltip': "Share of the session's substantive votes in which the bill was accepted. Only bill-deciding votes count — procedural and tie-break (Stichentscheid) votes are excluded, and votes where a 'Yes' actually rejects a proposal are scored by their real outcome.",
  'sessions.passedTooltipBasis': 'Based on {decided} substantive votes of {total} divisions held.',
  'sessions.meetings': 'Meetings',
  'sessions.agenda': 'Meetings & Agenda',
  'sessions.votes': 'Votes',
  'sessions.agendaItems': 'Agenda Items',
  'sessions.totalYes': 'Total Yes',
  'sessions.totalNo': 'Total No',
  'sessions.voteCount': 'Vote Count',
  'sessions.backToSessions': 'Back to Sessions',
  'sessions.noSubjects': 'No subjects on record.',
  'sessions.noMeetings': 'No meeting data available.',
  'sessions.totalVotesCast': 'Total Votes Cast',
  'sessions.voteList': 'Vote List',
  'sessions.spring': 'Spring',
  'sessions.summer': 'Summer',
  'sessions.autumn': 'Autumn',
  'sessions.winter': 'Winter',
  'sessions.special': 'Special',
  'sessions.allSeasons': 'Sessions',
  'sessions.yesNo': 'Yes / No',
  'sessions.liveBannerTitle': 'Parliament is in session right now',
  'sessions.liveBannerEnds': 'Ends',
  'sessions.attendance': 'Attendance',
  'sessions.attendanceTip': 'Council members ranked by absence rate this session (not participating or excused). Filter by parliamentary group to narrow the list.',
  'sessions.attendanceEmpty': 'No individual vote data available for this session yet.',
  'sessions.calendarGrid': 'Session Calendar',
  'sessions.items': 'items',
  'session.discussion.topSpeakers': 'Top speakers',
  'session.discussion.summary':     'Debate summary',
  'session.discussion.speeches':    'speeches',
  'session.discussion.avgEmotion':  'Ø emotionality',
  'session.topics.policyAreas':     'Policy areas',
  'session.topics.keywords':        'Top topics this session',
  // parties
  'parties.title': 'Parties & Parliamentary groups',
  'parties.subtitle': 'Seat distribution, gender balance, and council breakdown.',
  'parties.activeMembers': 'Active Members',
  'parties.nationalCouncil': 'National Council',
  'parties.statesCouncil': 'States Council',
  // Faction code → recognisable party short-name (unity-ranking axis labels)
  'faction.party.V':   'SVP',
  'faction.party.S':   'SP',
  'faction.party.G':   'Greens',
  'faction.party.GL':  'GLP',
  'faction.party.RL':  'FDP',
  'faction.party.M-E': 'Die Mitte',
  'faction.party.BD':  'BDP',
  'parties.femalePct': 'Female %',
  'parties.malePct': 'Male %',
  'parties.seatDistribution': 'Seat Distribution by Parliamentary group',
  'parties.nrSrSplit': 'Council Chamber Distribution by Parliamentary group',
  'parties.genderByFaction': 'Gender by Parliamentary group',
  'parties.femalePctByFaction': 'Female % by Parliamentary group',
  'parties.factionDetails':      'Parliamentary group Details',
  'parties.ideologicalSpectrum': 'Ideological Spectrum (Left ↔ Right)',
  'parties.spectrum.expert': 'Expert consensus',
  'parties.spectrum.data': 'Voting data',
  'parties.spectrum.dataNote': 'computed from pairwise parliamentary group voting agreement in parliamentary records',
  'parties.spectrum.dataTip': 'Position on the left–right axis derived from actual voting patterns — how similarly each parliamentary group votes compared to SVP (right anchor) vs SP (left anchor), normalised to [−3, +3].',
  'parties.seats': 'Seats',
  'parties.female': 'Female',
  'parties.parties': 'Parties',
  'parties.viewMembers': 'View Members',
  'parties.cohesion':    'Cohesion',
  'parties.cantonDistribution': 'Cantonal Map',
  'parties.dominantFaction': 'Dominant parliamentary group',
  // parties — tabs
  'parties.tab.assembly': 'Current Assembly',
  'parties.tab.assemblyTip': 'The current Federal Assembly — the National Council and Council of States combined. See the dominant parliamentary group in each canton and where every member sits in both chambers.',
  'parties.tab.factions': 'Parliamentary groups',
  'parties.tab.factionsTip': 'A Fraktion (parliamentary group) may combine members from multiple parties. E.g., EVP and Die Mitte both sit in Fraktion M-E.',
  'parties.tab.parties': 'Political Parties',
  'parties.tab.partiesTip': 'Political parties as registered organisations. A party member\'s Fraktion (parliamentary group) may differ from their party if multiple parties share a parliamentary group.',
  // parties — map
  'parties.mapTooltipSeats': 'seats',
  'parties.factionFilterTip': 'Highlight one or more parliamentary groups across both chambers; the rest dim out.',
  'parties.mapTooltipDominant': 'Dominant',
  'parties.mapClickHint': 'Click a canton to highlight its members in the seating charts below',
  // parties — faction card / drill-down
  'parties.viewFaction': 'Parliamentary group Profile →',
  'parties.noFactions':   'No parliamentary group data available.',
  'parties.nonAligned':   'Non-aligned / Parteilos',
  // parties — political parties tab
  'parties.party.active': 'active',
  'parties.party.founded': 'Founded',
  'parties.party.dissolved': 'Dissolved',
  'parties.party.noParties': 'No party data available.',
  'parties.party.historical':     'Historical',
  'parties.party.showHistorical': 'Show historical parties',
  'parties.party.hideHistorical': 'Hide historical parties',
  // parties — KPI cards
  'parties.kpiSubtitle': 'Parliament-wide totals across all parliamentary groups',
  'parties.genderBalance': 'Gender Balance',
  'parties.avgCohesion': 'Avg Cohesion',
  'parties.acrossFactionsNote': 'across parliamentary groups',
  // parties — chart card titles
  'parties.dominantFactionByCanton': 'Dominant Parliamentary group by Canton',
  'parties.nrSeatsByFaction': 'National Council — Seat Distribution by Parliamentary group',
  'parties.srSeatsByFaction': 'States Council — Seat Distribution by Parliamentary group',
  'parties.dominantPartyByCanton': 'Dominant Party by Canton',
  'parties.nrSeatsByParty': 'National Council — Seat Distribution by Party',
  'parties.srSeatsByParty': 'States Council — Seat Distribution by Party',
  'parties.dominantFactionByCantonTip': 'The strongest parliamentary group in each canton by seat count. Click a canton to highlight its members in the seating charts below.',
  'parties.hemicycleTip': 'Each dot is one seat, arranged by parliamentary group from left to right. Hover a dot or click a group in the legend to isolate it.',
  'parties.genderByFactionTip': 'Share of women in each parliamentary group. The dashed line marks the parliament-wide average.',
  'parties.nrSrSplitTip': 'How each parliamentary group\'s seats split between the National Council and the States Council. Toggle "% view" to compare shares instead of absolute seat counts.',
  'parties.seatingTip': 'The real chamber floor plan — every councillor at their actual seat, from the official parliament seating plan. Hover a seat for an overview; click to open the profile.',
  'parties.seating.seat': 'Seat',
  'parties.seating.noData': 'No seating data available yet',
  'parties.seating.canton': 'Canton',
  'parties.seating.since': 'In parliament since',
  'parties.seating.years': 'yrs',
  'parties.seating.role': 'Role',
  'parties.seating.participation': 'Vote participation',
  'parties.seating.cohesion': 'Cohesion',
  'parties.seating.committees': 'Committees',
  'parties.seating.profession': 'Profession',
  'parties.seating.viewProfile': 'Click to open profile',
  'parties.legislature': 'Legislature',
  'parties.current': 'current',
  'parties.seatingCurrentBadge': 'Current chamber',
  'parties.pastLegVoteNote': 'Voting-behaviour charts (cohesion, alliances, ideological spectrum) are based on recorded roll-call votes in the selected legislature, across both chambers where available (Council of States votes are recorded only from 2022).',
  'parties.currentChamberNote': 'Chamber snapshot · current legislature',
  'parties.analyticsSection': 'Composition & voting analysis',
  // parties — ideological spectrum
  'parties.naExcluded': 'Non-aligned (NA) excluded — mixed independents with no consensus ideological position.',
  'parties.allianceMatrix': 'Parliamentary group Alliance Matrix',
  'parties.allianceMatrixTip': 'Percentage of votes where both parliamentary groups voted the same way (yes/no majority aligned). 100% = always together, 0% = always opposed.',
  'parties.allianceMatrixNote': 'Based on all recorded votes. Higher % = parliamentary groups vote together more often.',
  'parties.cohesionTrend': 'Parliamentary group unity over time',
  'parties.partyUnityTrend': 'Party unity over time',
  'parties.cohesionTrendTip': 'Parliamentary group voting unity per parliamentary session. Unity = average % of members voting with their parliamentary group majority.',
  'parties.spectrumClosest': 'Ideologically closest:',
  'parties.spectrumFurthest': 'Furthest apart:',
  'parties.spectrumPtsApart': 'pts apart',
  'parties.spectrumGapNote': 'Expert↔Voting gap',
  'parties.votesMoreRight': 'votes more right',
  'parties.votesMoreLeft': 'votes more left',
  // parties — gender chart
  'parties.genderAvgLine': 'Parliament avg',
  'parties.genderAvgTooltip': 'Parliament-wide female average',
  // parties — faction table tooltips
  'parties.seatsShareTooltip': 'Share of all parliamentary seats',
  'parties.naChambersNote': 'Members hold executive roles (e.g. Federal Council) not assigned to a parliamentary chamber',
  'parties.cohesionTooltip': 'Cohesion measures how unified a parliamentary group votes. 100% means all members always vote together. Lower values indicate internal splits or crossover voting. Colour: green ≥92%, amber 85–92%, red <85%.',
  // parties — party table
  'parties.party.searchPlaceholder': 'Search parties…',
  'parties.party.noCurrentMembers': 'Currently not represented in parliament',
  'parties.party.nameColumn': 'Party',
  'parties.party.abbrColumn': 'Abbr.',
  'parties.party.factionColumn': 'Parliamentary group',
  'parties.party.factionColumnTitle': 'Parliamentary parliamentary group this party belongs to',
  'parties.party.historicalSubtitle': 'Parties with a recorded dissolution date — includes mergers, renames, and disbanded organisations.',
  // parties — historical era labels
  'parties.party.era.pre1960': 'Before 1960',
  'parties.party.era.196070': '1960s–70s',
  'parties.party.era.198090': '1980s–90s',
  'parties.party.era.2000s': '2000s–early 2010s',
  'parties.party.era.present': '2015 — present',
  'parties.party.singular': 'party',
  'parties.party.plural': 'parties',
  // faction detail page
  'faction.backToParties': 'Back to Parties',
  'faction.overview': 'Overview',
  'faction.members': 'Members',
  'faction.interests': 'Lobbying & Interests',
  'faction.statsNR': 'National Council',
  'faction.statsSR': 'States Council',
  'faction.statsFemale': 'Female',
  'faction.statsMale': 'Male',
  'faction.memberCount': 'members',
  'faction.interestsByType': 'Interests by Type',
  'faction.topOrganizations': 'Top Organizations',
  'faction.paid': 'Paid',
  'faction.unpaid': 'Unpaid',
  'faction.noInterests': 'No lobbying interests data available for this parliamentary group.',
  'faction.councillorsCount': 'council members',
  'faction.cantonBreakdown': 'Members by Canton',
  'faction.recentVotes':     'Recent Votes',
  'faction.factionVote':     'Parliamentary group Vote',
  // overview
  'overview.title': 'Parlumina',
  'overview.subtitle': 'Live data from the Swiss Federal Assembly.',
  'overview.councillors': 'Council members',
  'overview.activeAffairs': 'Active Affairs',
  'overview.votesThisYear': 'Votes This Year',
  'overview.currentSession': 'Current Session',
  'overview.activityTrends': 'Activity Trends',
  'overview.votesBySession': 'Votes by Session',
  'overview.partyComposition': 'Party Composition',
  'overview.recentDebates': 'Recent Debates Feed',
  'overview.passRate': 'Pass Rate This Year',
  'overview.viewAll': 'View all',
  'overview.sessionLive': 'Live',
  'overview.sessionEnded': 'ended',
  'overview.sessionUpcoming': 'starts in',
  'overview.speeches': 'speeches',
  'overview.seats': 'Seats',
  'overview.hotTopics': 'Recently Discussed',
  'overview.allLang': 'All',
  'overview.vsLastSession': 'vs. last session',
  'overview.ofVotes': 'of {n} votes',
  'overview.nrSrSplit': '{nr} NR · {sr} SR · +{br} BR · +{bk} BK',
  'overview.submittedThisYear': '{n} submitted this year',
  'overview.allChambers': 'all chambers',
  'overview.vsYear': 'vs. {year}',
  'overview.highImpactBills': 'High-Impact Bills',
  'overview.viewDetails': 'View details',
  'overview.federalPush': 'Federal push',
  'overview.balanced': 'Balanced',
  'overview.cantonalLean': 'Cantonal lean',
  'overview.impactTooltipTitle': 'Legislative Impact',
  'overview.impactTooltipText': 'How significantly this bill changes Swiss law or public policy. Scored 1–10 by AI.',
  'overview.sensitivityTooltipTitle': 'Political Sensitivity',
  'overview.sensitivityTooltipText': 'Degree of political controversy or cross-party tension this bill generates. Scored 1–10 by AI.',
  'overview.chart.clickToOpenSession': 'Click to open session',

  // Members table headers (4.8 — gap fixes)
  'member.council': 'Council',
  'member.age':     'Age',

  // Bills — type-tooltip descriptions (4.8 — gap fixes)
  'bills.type.tip.motion':            'Motion — binding instruction to the Federal Council to introduce legislation or take action.',
  'bills.type.tip.postulate':         'Postulate — non-binding recommendation asking the Federal Council to examine a topic.',
  'bills.type.tip.interpellation':    'Interpellation — written questions to the Federal Council requiring a formal written response.',
  'bills.type.tip.parlInitiative':    'Parliamentary Initiative — a member proposes a bill directly without involving the Federal Council.',
  'bills.type.tip.cantonInitiative':  'Cantonal Initiative — a canton proposes a federal constitutional or legislative change.',
  'bills.type.tip.groupMotion':       'Group Motion — a motion submitted jointly by an entire parliamentary group.',
  'bills.type.tip.simpleQuestion':    'Simple Question — a brief written question to the Federal Council.',
  'bills.type.tip.federalCouncilBill':'Federal Council Bill — a bill introduced directly by the executive branch.',
  'bills.type.tip.urgentInterp':      'Urgent Interpellation — an interpellation that requires an urgent response.',
  'bills.type.tip.urgentSimple':      'Urgent Simple Question — an urgent brief written question to the Federal Council.',
  'bills.type.tip.urgentQuestion':    'Urgent Question — requires an immediate answer from the Federal Council.',
  'bills.type.tip.recommendation':    'Recommendation — a non-binding recommendation to a commission or authority.',
  'bills.type.tip.petition':          'Petition — a request submitted to parliament by citizens.',
  'bills.type.tip.parlGroupMotion':   'Parliamentary Group Motion — a motion submitted by a parliamentary group.',

  // Usage page (admin / developer-only cost dashboard)
  'usage.title':                  'Usage',
  'usage.subtitle':               'Token consumption and estimated cost across all chat clients.',
  'usage.errorLoad':              'Failed to load usage',
  'usage.range.7d':               'Last 7 days',
  'usage.range.30d':              'Last 30 days',
  'usage.range.90d':              'Last 90 days',
  'usage.range.365d':             'Last year',
  'usage.kpi.messages':           'Messages',
  'usage.kpi.messagesHint':       'One per question asked',
  'usage.kpi.apiCalls':           'API calls',
  'usage.kpi.apiCallsHint':       'Anthropic responses (incl. tool-call iters)',
  'usage.kpi.estimatedCost':      'Estimated cost',
  'usage.kpi.costPer100':         '{cost} per 100 messages',
  'usage.kpi.totalTokens':        'Total tokens',
  'usage.kpi.titleGenCost':       'Title-gen cost',
  'usage.kpi.cacheHitRate':       'Cache hit rate',
  'usage.kpi.cacheHitRateHint':   'Saved {saved} · {eff} of cacheable prefix hit',
  'usage.col.hitRate':            'Hit rate',
  'usage.kpi.titleGenHint':       'Groq Llama 3.1 8B',
  'usage.kpi.users':              'Users',
  'usage.legend.input':           'Input',
  'usage.legend.output':          'Output',
  'usage.legend.cacheRead':       'Cache read',
  'usage.legend.cacheCreate':     'Cache create',
  'usage.perModelTitle':          'Per model (chat agent)',
  'usage.col.model':              'Model',
  'usage.col.msgs':               'Msgs',
  'usage.col.input':              'Input',
  'usage.col.output':             'Output',
  'usage.col.cacheRead':          'Cache read',
  'usage.col.cacheCreate':        'Cache create',
  'usage.col.estCost':            'Est. cost',
  'usage.unknownModel':           'unknown',
  'usage.titleGenTitle':          'Title generation',
  'usage.titleGenNote':           '(Groq, separate provider)',
  'usage.titleGen.col.sessionsTitled':    'Sessions titled',
  'usage.titleGen.col.promptTokens':      'Prompt tokens',
  'usage.titleGen.col.completionTokens':  'Completion tokens',
  'usage.pillLabelTitle':                 'Filter pill labels',
  'usage.pillLabelNote':                  '(Groq, per-turn — non-critical UI polish)',
  'usage.pillLabel.col.turnsLabelled':    'Turns labelled',
  'usage.perUserTitle':           'Per user',
  'usage.perUserCount':           '({count} total)',
  'usage.showMore':               'Show {count} more',
  'usage.collapse':               'Collapse',
  'usage.user.col.user':          'User',
  'usage.user.col.sessions':      'Sessions',
  'usage.user.col.messages':      'Messages',
  'usage.user.col.apiCalls':      'API calls',
  'usage.user.col.cacheRW':       'Cache R/W',
  'usage.user.col.costPer100':    '$ / 100 messages',
  'usage.user.col.lastActivity':  'Last activity',
  'usage.user.nameUnknown':       'name unknown',
  'usage.footnote':               'Message = one conversation exchange: the user\'s question + all internal tool-calling iterations + the AI\'s final answer, counted as one. API calls is the raw count of Anthropic responses (≥ messages, since the agent fires one API call per iteration). Cost & tokens are summed across all calls. $ / 100 messages is the budget projection — at the current per-message cost, what would 100 messages run? Estimates only — actual provider invoice may differ. Title generation: Groq Llama 3.1 8B Instant ($0.05 / $0.08 per M). Chat agent: Anthropic Claude Haiku 4.5 ($1 input / $5 output per M, cache reads $0.10, 5-min cache writes $1.25).',

  // ── Settings page ──────────────────────────────────────────────────────────
  'settings.title':                  'Settings',
  'settings.subtitle':               'Manage your preferences, notifications, and system data.',
  'settings.manageAccount':          'Manage account',
  'settings.tab.preferences':        'Preferences',
  'settings.tab.notifications':      'Notifications',
  'settings.tab.managePresets':      'Manage Presets',
  'settings.tab.system':             'System',
  'settings.appearance':             'Appearance',
  'settings.theme':                  'Theme',
  'settings.theme.desc':             'Dashboard colour scheme.',
  'settings.theme.light':            'Light',
  'settings.theme.dark':             'Dark',
  'settings.theme.system':           'System',
  'settings.language':               'Language',
  'settings.language.desc':          'Language for data labels and UI.',
  'settings.navigation':             'Navigation',
  'settings.landingPage':            'Default landing page',
  'settings.landingPage.desc':       'Page shown after login.',
  'settings.aiChat':                 'AI Chat',
  'settings.showWidget':             'Show chat widget',
  'settings.showWidget.desc':        'Display the InnoChat assistant on all pages.',
  'settings.about':                  'About',
  'settings.appVersion':             'App version',
  'settings.appVersion.desc':        'Parlumina',
  'settings.dataSource':             'Data source',
  'settings.dataSource.desc':        'Swiss Federal Assembly open data.',
  'settings.dataUpdated':            'Data updated',
  'settings.dataUpdated.desc':       'Most recent record synced from the parliamentary record.',
  'settings.dataUpdated.unknown':    'Unknown',
  'settings.aiAssistant':            'AI assistant',
  'settings.aiAssistant.desc':       "Powered by INNOCHAT — InnoQ's AI platform.",
  'settings.alertPrefs':             'Alert preferences',
  'settings.alert.votes':            'Vote results',
  'settings.alert.votes.desc':       'Notify when a tracked bill goes to a final vote.',
  'settings.alert.bills':            'Bill status changes',
  'settings.alert.bills.desc':       'Alert when a watched bill advances or concludes.',
  'settings.alert.browser':          'Browser notifications',
  'settings.alert.browser.blocked':  'Blocked by browser — change in site settings.',
  'settings.alert.browser.desc':     'Enable push notifications in this browser.',
  'settings.watchlist':              'Watchlist',
  'settings.watchlist.members':      'Watched members',
  'settings.watchlist.bills':        'Watched bills',
  'settings.watchlist.empty':        'Nothing saved yet.',
  'settings.watchlist.countOne':     '1 item saved.',
  'settings.watchlist.countMany':    '{n} items saved.',
  'settings.watchlist.manage':       'Manage',
  'settings.tags':                   'Tags',
  'settings.presets.signIn':         'Sign in to manage your saved presets.',
  'settings.presets.title':          'Saved presets',
  'settings.presets.empty':          'No saved presets yet. On Members, Bills, Debates, or Votes, set the filters you want and click Save filter to keep them here.',
  'settings.presets.deleteTooltip':  'Delete preset',
  'settings.presets.delete':         'Delete',
  'settings.presets.updated':        'Updated {date}',
  'settings.presets.countOne':       '1 preset',
  'settings.presets.countMany':      '{n} presets',
  'settings.presets.loadError':      'Failed to load presets',
  'settings.presets.deleteError':    'Delete failed',
  'settings.developer':              'Developer',
  'settings.chatProvider':           'Chatbot model provider',
  'settings.chatProvider.label':     'Active provider',
  'settings.chatProvider.desc':      'Developer control. Switches which LLM answers the chatbot for ALL users — not just you. Applies on the next turn.',
  'settings.chatProvider.anthropic': 'Anthropic (Claude Sonnet)',
  'settings.chatProvider.openai':    'OpenAI (GPT-5.4 mini)',
  'settings.chatProvider.loadError': "Couldn't load the current provider.",
  'settings.chatProvider.saveError': "Couldn't switch provider. Try again.",
  'settings.devInspector':           'Dev inspector',
  'settings.devInspector.desc':      "Show the agent's tool calls, args, and result previews under each AI reply. Turn off to see the chat exactly as a regular user does.",
  // citations + speech/vote correlation
  'debates.conditional': 'Cond.',
  'citation.type.councillor': 'Profile',
  'citation.type.affair': 'Affair',
  'citation.type.dispatch': 'Botschaft',
  'citation.type.speech': 'Speech',
  'citation.source': 'Source',
  'citation.aria': 'Source {id}: {label}',
  // chat widget
  'chat.entity.member': 'Member',
  'chat.entity.session': 'Session',
  'chat.entity.bill': 'Bill',
  'chat.entity.vote': 'Vote',
  'chat.entity.debate': 'Debate',
  'chat.entity.faction': 'Parliamentary group',
  'chat.context.dashboard': 'Parliament Dashboard',
  'chat.viewing': 'Viewing:',
  'chat.context.syncActive': 'The assistant knows what you\'re viewing — the page you\'re on, plus any filters you apply and any item you open here.',
  'chat.context.syncInactive': 'No page context to share here — the assistant answers general questions. Open a data page to ask about what you\'re viewing.',
  'chat.toast.newSession': 'New session started',
  'chat.fab.aria': 'Open parliament AI chat',
  'chat.collapse': 'Collapse',
  'chat.expand': 'Expand',
  'chat.newSession': 'New session',
  'chat.mode.speed': 'Speed',
  'chat.mode.quality': 'Quality',
  'chat.mode.speedTip': 'Fast answers — low latency, good quality',
  'chat.mode.qualityTip': 'Best quality — deeper answers, higher latency',
  'chat.dashboardFiltered': 'Dashboard filtered:',
  'chat.clearFilter': 'Clear filter',
  'chat.input.placeholder': 'Ask about parliament…',
  'chat.input.signingIn': 'Signing in…',
  'chat.send': 'Send message',
  'chat.stop': 'Stop generating',
  'chat.stopped': 'Stopped.',
  // multi-select control + canton map tooltip
  'multiselect.selected': '{n} selected',
  'multiselect.noOptions': 'No options',
  'cantonMap.dominantParty': 'Dominant party',
  'cantonMap.faction': 'Parliamentary group',
  'cantonMap.dominantFaction': 'Dominant parliamentary group',
  'cantonMap.party': 'Party',
  // member activity chart
  'common.pp': 'pp',
  'member.activity.voteParticipation': 'Vote participation',
  'member.activity.participation': 'Participation',
  'member.activity.votesOfTotal': '{n} of {total} votes',
  // localization pass: bill detail / parties / session detail
  'billDetail.typeTip.motion': 'Motion — binding instruction to the Federal Council to introduce legislation or take action.',
  'billDetail.typeTip.postulate': 'Postulate — non-binding recommendation asking the Federal Council to examine a topic.',
  'billDetail.typeTip.interpellation': 'Interpellation — written questions to the Federal Council requiring a formal written response.',
  'billDetail.typeTip.parliamentaryInit': 'Parliamentary Initiative — a member proposes a bill directly without involving the Federal Council.',
  'billDetail.typeTip.cantonalInit': 'Cantonal Initiative — a canton proposes a federal constitutional or legislative change.',
  'billDetail.typeTip.groupMotion': 'Group Motion — a motion submitted jointly by an entire parliamentary group.',
  'billDetail.typeTip.simpleQuestion': 'Simple Question — a brief written question to the Federal Council.',
  'billDetail.typeTip.federalCouncilBill': 'Federal Council Bill — a bill introduced directly by the executive branch.',
  'billDetail.typeTip.urgentInterpellation': 'Urgent Interpellation — an interpellation that requires an urgent response.',
  'billDetail.typeTip.urgentSimpleQuestion': 'Urgent Simple Question — an urgent brief written question to the Federal Council.',
  'billDetail.typeTip.urgentQuestion': 'Urgent Question — requires an immediate answer from the Federal Council.',
  'billDetail.typeTip.recommendation': 'Recommendation — a non-binding recommendation to a commission or authority.',
  'billDetail.typeTip.petition': 'Petition — a request submitted to parliament by citizens.',
  'billDetail.typeTip.parliamentaryGroupMotion': 'Parliamentary Group Motion — a motion submitted by a parliamentary group.',
  'billDetail.pipeline.submitted': 'Submitted',
  'billDetail.pipeline.review': 'In Review',
  'billDetail.pipeline.vote': 'Final Vote',
  'billDetail.pipeline.concluded': 'Concluded',
  'billDetail.tab.debates': 'Speeches',
  'billDetail.tab.activity': 'Activity',
  'billDetail.tab.votes': 'Votes',
  'billDetail.tab.similar': 'Similar Business',
  'billDetail.furtherDocs': 'Further documents',
  'billDetail.officialBulletin': 'Official Bulletin',
  'billDetail.notFound': 'Affair not found.',
  'billDetail.lp.title': 'Legislative Period',
  'billDetail.meta.status': 'State of Deliberations',
  'billDetail.meta.legislativePeriod': 'Legislative Period',
  'billDetail.meta.commission': 'Committee',
  'billDetail.meta.category': 'Debate Category',
  'billDetail.category.I': 'Free Debate',
  'billDetail.category.II': 'Organised Debate',
  'billDetail.category.III': 'Group Debate',
  'billDetail.category.IV': 'Short Debate',
  'billDetail.category.V': 'Reduced Procedure',
  'billDetail.lp.tooltip': 'The four-year term of the Federal Assembly during which the elected members serve.',
  'billDetail.triggerTip.popularInitiative': 'Popular Initiative — citizens may propose a change to the Federal Constitution by collecting 100,000 valid signatures within 18 months. Referendum — a law passed by parliament can be put to a nationwide vote if 50,000 signatures are gathered within 100 days.',
  'billDetail.triggerTip.intlMandates': 'Driven by obligations from international bodies (EU, OECD, UN) that Switzerland must transpose into national law.',
  'billDetail.triggerTip.judicialRulings': 'Prompted by a court decision (e.g. the Federal Supreme Court or the ECtHR) that requires legislation to be adapted.',
  'billDetail.triggerTip.techShift': 'A response to new technology or digital developments that existing law does not yet cover.',
  'billDetail.triggerTip.globalCrisis': 'Triggered by an international crisis (pandemic, war, financial shock) demanding a legislative response.',
  'billDetail.triggerTip.internalInitiative': 'Originates within parliament or the federal administration rather than from an external event.',
  'billDetail.triggerTip.generic': 'The external event or process that prompted this parliamentary business.',
  'billDetail.tags.label': 'Topics',
  'billDetail.debates.councilFilter': 'Council',
  'billDetail.debates.showingRange': 'Showing {from}–{to} of {total} speeches',
  'billDetail.debates.pageOf': 'Page {page} of {pages}',
  'billDetail.meta.submitted': 'Submitted',
  'billDetail.meta.statusDate': 'Status Date',
  'billDetail.description': 'Description',
  'billDetail.noShortDescription': 'No short description available for this affair.',
  'billDetail.viewFullText': 'View full text',
  'billDetail.submittedTo': 'Submitted to: ',
  'billDetail.activityTimeline': 'Activity Timeline',
  'billDetail.fullText.initialSituation': 'Initial Situation',
  'billDetail.fullText.submittedText': 'Submitted Text',
  'billDetail.fullText.reason': 'Reason / Motivation',
  'billDetail.fullText.motion': 'Motion / Request',
  'billDetail.noFullText': 'No full text available.',
  'billDetail.proposalCode': 'Proposal code',
  'billDetail.council.response': 'Federal Council Response',
  'billDetail.council.proposalText': 'Proposal Text',
  'billDetail.council.proposal': 'Federal Council Proposal',
  'billDetail.council.proposalCodeTip': "The code the official parliamentary data uses for the Federal Council's recommendation (e.g. 44 = accept, 45 = reject, 46 = partial acceptance). The label shows its meaning.",
  'billDetail.council.proceedings': 'Proceedings',
  'billDetail.council.noResponse': 'No Federal Council response available.',
  'billDetail.debates.loadError': 'Could not load debates. The search index may be temporarily unavailable.',
  'billDetail.debates.empty': 'No parliamentary speeches found for this affair.',
  'billDetail.debates.emptyChamber': 'No speeches from this chamber for this business.',
  'billDetail.votes.emptyChamber': 'No votes from this chamber for this business.',
  'billDetail.debates.stateRep': 'State Rep.',
  'billDetail.debates.amendmentProposed': 'Amendment proposed',
  'billDetail.debates.amendment': 'amendment',
  'billDetail.debates.emotionality': 'Emotionality',
  'parties.noData': 'No data',
  'parties.totalSuffix': 'total',
  'parties.nrSeats': 'NR seats',
  'parties.srSeats': 'SR seats',
  'parties.csv.abbreviation': 'Abbreviation',
  'parties.csv.name': 'Name',
  'parties.csv.total': 'Total',
  'parties.csv.nr': 'NR',
  'parties.csv.sr': 'SR',
  'parties.csv.female': 'Female',
  'parties.csv.male': 'Male',
  'parties.csv.cohesion': 'Cohesion (%)',
  'parties.csv.activeMembers': 'Active Members',
  'parties.csv.founded': 'Founded',
  'parties.avg': 'Avg',
  'parties.spectrum.left': 'Left',
  'parties.spectrum.right': 'Right',
  'parties.selfAlways100': 'Self — always 100%',
  'parties.agreement': 'Agreement',
  'parties.recordedVotesCount': '{a} of {b} recorded votes',
  'parties.recordedVotes': 'recorded votes',
  'parties.cohesionAxis': 'Unity (%)',
  'parties.threshold90': '90% threshold',
  'parties.chamber.nr': 'National Council',
  'parties.chamber.sr': 'Council of States',
  'parties.cohesionNoChamberData': 'No Council of States cohesion data for this period — per-member roll-calls exist only from 2022.',
  'parties.filteredBy': 'Filtered by:',
  'parties.filtered': 'Filtered:',
  'parties.nonAlignedFootnote': '{count} non-aligned not shown — members hold executive roles (Federal Council) not assigned to a parliamentary chamber.',
  'parties.pctView': '% view',
  'parties.sort': 'Sort:',
  'parties.sortLeftRight': 'Left → Right',
  'parties.sortAlphabetical': 'Alphabetical',
  'parties.self': 'Self',
  'parties.seatsProportionTitle': 'Proportion of all parliamentary seats',
  'parties.nrShort': 'NR',
  'parties.srShort': 'SR',
  'parties.notAffiliatedTitle': 'Members not affiliated with any registered party',
  'sessionDetail.councilVbv': 'VBV',
  'sessionDetail.councilVbvFull': 'United Federal Assembly',
  'sessionDetail.noSrVotes': 'No Council of States roll-call votes recorded for this session (available from 2022).',
  'sessionDetail.donutTooltip': 'Sum of every individual Yes / No / abstention ballot cast across all of this session’s roll-call votes — total ballots, not the number of votes.',
  'sessionDetail.kpiAcceptedTooltip': 'How many of the session’s bill-deciding votes ended with the proposal accepted (and their share). Procedural and tie-break votes are excluded; votes where a “Yes” rejects a proposal are counted by their real outcome.',
  'sessionDetail.kpiRejectedTooltip': 'How many bill-deciding votes ended with the proposal rejected (and their share). Same basis as the accepted figure — procedural and tie-break votes excluded.',
  'sessionDetail.kpiParticipationTooltip': 'Average number of council members casting a Yes, No or abstention per vote — i.e. those present and voting. Absences and excusals are not counted.',
  'sessionDetail.calendarCountHint': 'The number next to each chamber (e.g. NR · 11) is how many agenda items it handled that day.',
  'sessionDetail.noSession': 'No session',
  'sessionDetail.passRate': 'Pass Rate',
  'sessionDetail.searchAgenda': 'Search {n} agenda items…',
  'sessionDetail.avgParticipation': 'Avg participation',
  'sessionDetail.councillorsPerVote': 'council members / vote',
  'sessionDetail.votesPerDay': 'Votes per day',
  'sessionDetail.mostContested': 'Most contested',
  'sessionDetail.margin': 'margin',
  'sessionDetail.colAffair': 'Affair',
  'sessionDetail.colTitle': 'Title',
  'sessionDetail.colResult': 'Result',
  'sessionDetail.viewVoteBreakdown': 'View vote breakdown',
  'sessionDetail.absent': 'absent',
  'sessionDetail.votes': 'votes',
  'sessionDetail.totalAgendaItems': 'Total agenda items',
  'common.weekday.mon': 'Mon',
  'common.weekday.tue': 'Tue',
  'common.weekday.wed': 'Wed',
  'common.weekday.thu': 'Thu',
  'common.weekday.fri': 'Fri',
  'common.weekday.sat': 'Sat',
  // localization pass 2: votes / members / bills / sessions / debates
  'votes.stichfrage': 'Stichfrage',
  'votes.yesShort': 'Y',
  'votes.noShort': 'N',
  'votes.factionSplit': 'Parliamentary group split',
  'votes.noData': 'no data',
  'votes.voteNumber': 'Vote #',
  'voteDetail.sortYesPct': 'Y%',
  'voteDetail.sortNoPct': 'N%',
  'voteDetail.sortAbstain': 'A',
  'voteDetail.sortTotal': '#',
  'voteDetail.sortName': 'A–Z',
  'voteDetail.sortLabel': 'Sort',
  'voteDetail.filterLabel': 'Filter',
  'voteDetail.sortYesPctTip': 'Sort by each group’s share of Yes votes (highest first)',
  'voteDetail.sortNoPctTip': 'Sort by each group’s share of No votes (highest first)',
  'voteDetail.sortAbstainTip': 'Sort by abstentions — members present who voted neither Yes nor No',
  'voteDetail.sortTotalTip': 'Sort by the total number of members in each group',
  'voteDetail.sortNameTip': 'Sort alphabetically by group name',
  'voteDetail.filterAllTip': 'Show every group',
  'voteDetail.filterYesTip': 'Only groups whose majority voted Yes',
  'voteDetail.filterNoTip': 'Only groups whose majority voted No',
  'voteDetail.filterSplitTip': 'Only groups with a tie — equal Yes and No votes',
  'voteDetail.csvFirstName': 'First Name',
  'voteDetail.csvLastName': 'Last Name',
  'voteDetail.csvCanton': 'Canton',
  'voteDetail.csvFaction': 'Parliamentary group',
  'voteDetail.csvDecision': 'Decision',
  'voteDetail.csvDecisionCode': 'Decision Code',
  'voteDetail.abstainShort': 'A',
  'voteDetail.absentShort': 'abs.',
  'voteAnalytics.cohesionSuffix': 'cohesion',
  'faction.notFound': 'Parliamentary group not found.',
  'faction.partyComposition': 'Party composition',
  'faction.memberSearchPlaceholder': 'Filter by name, canton, party…',
  'faction.canton': 'Canton',
  'faction.subjectCol': 'Subject',
  'faction.organizationCol': 'Organization',
  'faction.typeCol': 'Type',
  'faction.compensationCol': 'Compensation',
  'faction.interestsClickHint': 'Click a bar or label to filter the organizations below.',
  'faction.totalSuffix': 'total',
  'members.csv.name': 'Name',
  'members.csv.party': 'Party',
  'members.csv.faction': 'Parliamentary group',
  'members.csv.canton': 'Canton',
  'members.csv.council': 'Council',
  'members.csv.active': 'Active',
  'members.appliedByChatbot': 'Applied by chatbot',
  'bills.csv.number': 'Number',
  'bills.csv.title': 'Title',
  'bills.csv.type': 'Type',
  'bills.csv.status': 'Status',
  'bills.csv.submissionDate': 'Submission Date',
  'bills.scoreDots.impactDescription': 'How broadly this bill affects society, the economy, or public policy.',
  'bills.scoreDots.sensitivityDescription': 'How politically contested or divisive this bill is likely to be.',
  'common.other': 'Other',
  'memberDetail.speechCount': '{count} speeches',
  'memberCompare.remove': 'Remove',
  'sessions.csv.session': 'Session',
  'sessions.csv.abbreviation': 'Abbreviation',
  'sessions.csv.type': 'Type',
  'sessions.csv.startDate': 'Start Date',
  'sessions.csv.endDate': 'End Date',
  'sessions.csv.legislativePeriod': 'Legislative Period',
  'sessions.csv.votes': 'Votes',
  'sessions.csv.passRate': 'Pass Rate (%)',
  'sessions.passRateComparison': 'Pass rate comparison',
  'sessions.comparisonTitle': 'Session comparison',
  'sessions.vsLastSession': 'vs. last session',
  'sessions.vsSameSeasonLastYear': 'vs. same season last year',
  'sessions.passRateSuffix': '% pass',
  'debates.csv.date': 'Date',
  'debates.csv.speaker': 'Speaker',
  'debates.csv.faction': 'Parliamentary group',
  'debates.csv.canton': 'Canton',
  'debates.csv.council': 'Council',
  'debates.csv.businessNumber': 'Business Number',
  'debates.csv.businessTitle': 'Business Title',
  'debateDetail.missingSpeechId': 'Missing speech ID. Navigate here from a debate card.',
  'debateDetail.role.proponent': 'Proponent',
  'debateDetail.role.critic': 'Critic',
  'debateDetail.role.expert': 'Expert',
  'debateDetail.role.mediator': 'Mediator',
  'debateDetail.role.stateRep': 'State Rep.',
  'debateDetail.role.proponentDesc': 'Argues in favour of the proposal under debate — defends or promotes its adoption.',
  'debateDetail.role.criticDesc': 'Argues critically against the proposal — raises objections or opposition. Describes the rhetorical tone of the speech, not necessarily how the member voted.',
  'debateDetail.role.expertDesc': 'Speaks from subject-matter expertise, explaining or clarifying rather than taking a side.',
  'debateDetail.role.mediatorDesc': 'Seeks compromise or bridges the opposing positions in the debate.',
  'debateDetail.role.stateRepDesc': 'Speaks on behalf of the government / Federal Council (e.g. a minister), not as a party member.',
  'debateDetail.role.rapporteur': 'Rapporteur',
  'debateDetail.role.rapporteurDesc': 'Official committee spokesperson — presents the committee position formally to the chamber, not a personal stance.',
  'debateDetail.role.procedural': 'Procedural',
  'debateDetail.role.proceduralDesc': 'Speaks to process or procedure (points of order, agenda, voting mechanics) rather than the substance of the proposal.',
  'debateDetail.role.aiNote': 'AI-classified from the speech text. May differ from the member’s actual vote.',
  'debateDetail.sentiment.positive': 'Positive',
  'debateDetail.sentiment.neutral': 'Neutral',
  'debateDetail.sentiment.negative': 'Negative',
  'debateDetail.sentiment.positiveDesc': 'The overall emotional tone of the speech is positive — approving, optimistic, or supportive in wording.',
  'debateDetail.sentiment.neutralDesc': 'The overall emotional tone of the speech is neutral — factual or balanced, without a strong positive or negative charge.',
  'debateDetail.sentiment.negativeDesc': 'The overall emotional tone of the speech is negative — critical, disapproving, or pessimistic in wording. Reflects tone, not necessarily the member’s position.',
  'debateDetail.emotionality.tooltip': 'How emotionally charged the language of the speech is, on a 0–10 scale. Higher scores mean more forceful, passionate wording; lower scores mean a measured, matter-of-fact tone.',
  'debateDetail.alignment.forDesc': 'The speech supports the proposal under debate — argues for its adoption.',
  'debateDetail.alignment.againstDesc': 'The speech opposes the proposal under debate — argues against its adoption.',
  'debateDetail.alignment.neutralDesc': 'The speech takes no clear side for or against the proposal.',
  'debateDetail.alignment.conditionalDesc': 'The speech supports the proposal only if certain conditions or amendments are met.',
  'committee.memberHeading': 'Member',
  // localization pass 3: notifications / layout / cards / misc components
  'notif.unread': 'unread',
  'notif.ago.seconds': '{n}s ago',
  'notif.ago.minutes': '{n}m ago',
  'notif.ago.hours': '{n}h ago',
  'notif.ago.days': '{n}d ago',
  'doc.permalink': 'Permalink',
  'doc.breadcrumb': 'Breadcrumb',
  'doc.copy': 'Copy',
  'doc.copyCode': 'Copy code',
  'layout.expandSidebar': 'Expand Sidebar',
  'layout.collapseSidebar': 'Collapse Sidebar',
  'topbar.signIn': 'Sign In',
  'tags.removeTag': 'Remove tag',
  'tags.defaultColor': 'default',
  'card.untitledAffair': '(untitled affair)',
  'card.councillor': 'Council member',
  'card.unknownCouncillor': 'Unknown',
  'statusBadge.unknown': 'Unknown',
  'filterPreset.saveFailed': 'Save failed',
  'devInspector.toolCall': '{count} tool call',
  'devInspector.toolCalls': '{count} tool calls',
  'devInspector.iter': '{count} iter',
  'devInspector.iterationLine': 'Iter {iteration} · model {modelMs}ms · tools {toolMs}ms',
  'devInspector.argsCount': '{count} args',
  'devInspector.args': 'args',
  'devInspector.resultPreview': 'result preview',
  'chat.thinking': 'Thinking',
};

export default en;
